<template>
  <div class="callNumPanel">
    <div class="panel_title">
      <div class="panel_title_name">{{ doctorName }}</div>
      <span class="el-icon-close panel_title_close" @click="close"></span>
    </div>
    <div class="panel_current">
      <div class="panel_current_title">正在呼叫</div>
      <div class="panel_current_name">{{ currentMap.patientName || '暂无' }}</div>
      <div class="panel_current_operate">
        <el-button class="panel_current_btn" :disabled="[null, undefined, ''].includes(currentMap.physioQueueEntryId)" @click="callAgain(currentMap.physioQueueEntryId)">重呼</el-button>
        <el-button class="panel_current_btn" :disabled="[null, undefined, ''].includes(currentMap.physioQueueEntryId)" @click="missNum(currentMap.physioQueueEntryId)">过号</el-button>
      </div>
    </div>
    <el-button type="primary" class="panel_next" :disabled="waitingList.length === 0" @click="call()">呼叫下一位</el-button>
    <div class="info">
      <div class="info_tabList">
        <div :class="{ 'info_tab': true, 'active': tabActive === 0 }" @click="tabOn(0)">待签({{ pendingSignList.length }})</div>
        <div :class="{ 'info_tab': true, 'active': tabActive === 1 }" @click="tabOn(1)">待叫号({{ waitingList.length }})</div>
        <div :class="{ 'info_tab': true, 'active': tabActive === 2 }" @click="tabOn(2)">执行中({{ inProgressList.length }})</div>
        <div :class="{ 'info_tab': true, 'active': tabActive === 3 }" @click="tabOn(3)">已执行({{ finishedList.length }})</div>
      </div>
      <div class="info_list">
        <div v-for="item in list" :key="item.physioQueueEntryId" class="list_item">
          <div class="list_item_type">{{ item.assemblyQueueNo ? item.assemblyQueueNo : item.queueNoPrefix }}</div>
          <div class="list_item_name">{{ item.patientName }}</div>
          <div class="list_item_operate">
            <div v-if="tabActive === 1" class="list_btn primary" @click="call(item.physioQueueEntryId)">呼叫</div>
            <div v-if="tabActive === 2" class="list_btn" @click="missNum(item.physioQueueEntryId)">过号</div>
            <div v-if="tabActive === 2" class="list_btn primary" @click="callAgain(item.physioQueueEntryId)">重呼</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'CallNumPanel',
    data() {
      return {
        doctorId: '',
        doctorName: '',
        currentMap: {
          physioQueueEntryId: '',
          patientName: ''
        },
        tabActive: 1,
        pendingSignList: [],
        waitingList: [],
        inProgressList: [],
        finishedList: []
      }
    },
    computed: {
      list () {
        switch (this.tabActive) {
          case 0:
            return this.pendingSignList
          case 1:
            return this.waitingList
          case 2:
            return this.inProgressList
          case 3:
            return this.finishedList
          default:
            return this.waitingList
        }
      }
    },
    methods: {
      async getInfo () {
        const res = await req.get('/physio/signIn/queryPhysioSignList', {
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId
        })
        if (res.code == 200) {
          this.pendingSignList = res.data.pendingSignList || []
          this.waitingList = res.data.waitingList || []
          this.inProgressList = res.data.inProgressList || []
          this.finishedList = res.data.finishedList || []

          this.currentMap.physioQueueEntryId = ''
          this.currentMap.patientName = ''

          if (res.data.inProgressList.length > 0) {
            const current = res.data.inProgressList.find(v => { return v.queueStatus === 2 })
            if (current) {
              this.currentMap.physioQueueEntryId = current.physioQueueEntryId
              this.currentMap.patientName = current.patientName
            }
          }
        }
      },
      init () {
        const user = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user'))
        this.doctorId = user.doctorId
        this.doctorName = user.nickName

        this.tabActive = 1
        this.getInfo()
      },
      close () {
        this.$emit('close')
      },
      tabOn (key) {
        this.tabActive = key
        this.getInfo()
      },
      async call (id = null) {
        const res = await req.post('/physio/signIn/call', {
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          queueEntryId: id
        })
        if (res.code == 200) {
          this.$message.success('呼叫成功')
          this.getInfo()
        }
      },
      async callAgain (id = null) {
        const res = await req.post('/physio/signIn/recall', {
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          queueEntryId: id
        })
        if (res.code == 200) {
          this.$message.success('呼叫成功')
          this.getInfo()
        }
      },
      async missNum (id = null) {
        const res = await req.post('/physio/signIn/miss', {
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          queueEntryId: id
        })
        if (res.code == 200) {
          this.$message.success('已过号')
          this.getInfo()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .callNumPanel {
    box-sizing: border-box;
    width: 100%;
  }

  .panel_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .panel_title_name {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .panel_title_close {
    font-size: 16px;
    color: #9AA0A8;
    cursor: pointer;
  }

  .panel_current {
    box-sizing: border-box;
    margin: 12px 0 0 0;
    padding: 16px 24px;
    width: 100%;
    height: 138px;
    background-color: #E8F4FF;
    border-radius: 2px;
  }

  .panel_current_title {
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #667182;
  }

  .panel_current_name {
    margin: 8px 0 0 0;
    line-height: 30px;
    text-align: center;
    font-size: 20px;
    color: #000000;
  }

  .panel_current_operate {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .panel_next {
    margin: 8px 0 0 0;
    width: 100%;
  }

  .info {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .info_tabList {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    border-bottom: 1px solid #E0E0E0;
  }

  .info_tab {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    font-size: 14px;
    color: #667182;
    background-color: #F0F1F3;
    cursor: pointer;
    user-select: none;
  }

  .info_tab + .info_tab {
    border-left: 1px solid #E0E0E0;
  }

  .info_tab.active {
    color: #1890FF;
    background-color: #FFFFFF;
  }

  .info_list {
    width: 100%;
    height: 180px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #E0E0E0;
  }

  .list_item_type {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90px;
    height: 100%;
    font-size: 14px;
    color: #667182;
  }

  .list_item_name {
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    height: 100%;
    font-size: 14px;
    color: #667182;
  }

  .list_item_operate {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    height: 100%;
  }

  .list_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    height: 24px;
    font-size: 14px;
    color: #1F2329;
    background-color: #FFFFFF;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
  }

  .list_btn:hover {
    background-color: #ecf5ff;
  }

  .list_btn + .list_btn {
    margin: 0 0 0 12px;
  }

  .list_btn.primary {
    color: #1890FF;
    border-color: #1890FF;
  }
</style>